export default __webpack_public_path__ + "images/68cd57bf1ca6eb5b0a1b2a8b1a5943f3.png";